// extracted by mini-css-extract-plugin
module.exports = {"message":"LoadingView_message__xvdc9","loadingView":"LoadingView_loadingView__3-Gx3"};